export default __webpack_public_path__ + "static/media/6.350a4334.jpg";